import { Link2, Building, Key } from 'lucide-react';

export const CONNECTOR_CONFIGS = {
  dataeq: {
    name: 'DataEQ',
    description: 'Real-time conduct signal feed from DataEQ platform with support for multiple accounts',
    icon: <Link2 className="w-5 h-5" />,
    requiresCredentials: true,
    color: 'purple',
  },
  genesys: {
    name: 'Genesys Cloud',
    description: 'Contact center data and customer interaction analytics',
    icon: <Building className="w-5 h-5" />,
    requiresCredentials: false,
    color: 'blue',
  },
  icasework: {
    name: 'iCaseWork',
    description: 'Case management system integration for tracking customer issues',
    icon: <Key className="w-5 h-5" />,
    requiresCredentials: true,
    color: 'green',
  },
  salesforce: {
    name: 'Salesforce Service Cloud',
    description: 'Customer service cases and support interactions from Salesforce Service Cloud',
    icon: <Building className="w-5 h-5" />,
    requiresCredentials: true,
    color: 'orange',
  },
  qualtrics: {
    name: 'Qualtrics',
    description: 'Customer experience surveys and feedback data from Qualtrics Experience Management platform',
    icon: <Key className="w-5 h-5" />,
    requiresCredentials: true,
    color: 'cyan',
  },
} as const;

export type ConnectorType = keyof typeof CONNECTOR_CONFIGS;